import { render, staticRenderFns } from "./AlertBasic.vue?vue&type=template&id=79ac9db4"
import script from "./AlertBasic.vue?vue&type=script&lang=js"
export * from "./AlertBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports